
import { Emitter, Event } from "../../../../base/common/events.js";
import { Disposable } from "../../../../base/common/lifecycle.js";
import { IProjectService, ProjectDidChangeEvent } from "../common/project.js";
import { IHierarchyService } from "../../../../platform/hierarchy/common/hierarchy.js";
import { CancellationToken } from "../../../../base/common/cancellation.js";


export class BasicProjectService extends Disposable implements IProjectService {

    protected readonly _onDidChange = this._register(new Emitter<ProjectDidChangeEvent>());
    readonly onDidChange = this._onDidChange.event;

    constructor(
        @IHierarchyService readonly hierarchyService: IHierarchyService,
    ) {
        super();
        this._register(this.hierarchyService.onDidChange(() => { this._onDidChange.fire({ project: this }); }));
    }

    async add(obj: object, token?: CancellationToken): Promise<void> {
        await this.hierarchyService.add(obj, undefined, token);
        this._onDidChange.fire({ project: this });
    }

    async remove(obj: object): Promise<void> {
        this.hierarchyService.remove(obj);
        this._onDidChange.fire({ project: this });
    }
}



